// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__7nKXo","spinner-fullscreen":"Loading_spinner-fullscreen__XIpsp","spinner-fullscreen-spinner":"Loading_spinner-fullscreen-spinner__0Auzo"};